document.addEventListener("DOMContentLoaded", () => {
  (function () {
    const judgeme = document.querySelector("#judgeme_product_reviews");
    if (!judgeme) return;
    const getLinks = () => [
      ...document.querySelectorAll(
        ".jm-mfp-carousel .jdgm-gallery .jdgm-gallery__thumbnail-link"
      ),
    ];
    const getCurrentLinkIndex = (links) =>
      links.findIndex((v) =>
        v.classList.contains("jdgm-gallery__thumbnail-link--current")
      );
    $(judgeme).delegate(".jdgm-gallery__thumbnail-link", "click", (e) => {
      const current = e.currentTarget;
      const currentIndex = $(current).index();
      setTimeout(() => {
        const wrapper = document.querySelector(".jm-mfp-content-wrapper");
        const prevBtn = document.createElement("div");
        const nextBtn = document.createElement("div");
        prevBtn.className = "jm-mfp-content__prev disabled";
        nextBtn.className = "jm-mfp-content__next";
        wrapper?.appendChild(prevBtn);
        wrapper?.appendChild(nextBtn);
        // Event
        // 更新翻页按钮状态
        const updateNavigationBtn = (newIndex) => {
          const links = getLinks();
          if (newIndex == 0) {
            prevBtn.classList.add("disabled");
            nextBtn.classList.remove("disabled");
          } else if (newIndex == links.length - 1) {
            prevBtn.classList.remove("disabled");
            nextBtn.classList.add("disabled");
          } else {
            prevBtn.classList.remove("disabled");
            nextBtn.classList.remove("disabled");
          }
        };
        updateNavigationBtn(currentIndex);
        prevBtn.addEventListener("click", () => {
          const links = getLinks();
          const currentLinkIndex = getCurrentLinkIndex(links);
          let prevIndex = currentLinkIndex + 1;
          if (currentLinkIndex > 0) {
            prevIndex = currentLinkIndex - 1;
          } else {
            prevIndex = links.length - 1;
          }
          const prevLink = links[prevIndex];
          prevLink.click();
          updateNavigationBtn(prevIndex);
        });
        nextBtn.addEventListener("click", () => {
          const links = getLinks();
          const currentLinkIndex = getCurrentLinkIndex(links);
          let nextIndex = currentLinkIndex + 1;
          if (currentLinkIndex < links.length - 1) {
            nextIndex = currentLinkIndex + 1;
          } else {
            nextIndex = 0;
          }
          const nextLink = links[nextIndex];
          nextLink.click();
          updateNavigationBtn(nextIndex);
        });
        // 缩略图点击更新翻页按钮
        $(".jm-mfp-main").delegate(
          ".jdgm-gallery__thumbnail-link",
          "click",
          (e) => {
            const clickIndex = $(e.currentTarget).index();
            updateNavigationBtn(clickIndex);
          }
        );
      });
    });
  })();
});
